"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDesignEvaluationDefs = void 0;
var lodash_1 = __importDefault(require("lodash"));
var Config_1 = require("../../utils/Config");
var StringUtils_1 = require("../../utils/StringUtils");
var DayouReport_1 = require("./DayouReport");
var HelixmithReport_1 = require("./HelixmithReport");
var TPCReport_1 = require("./TPCReport");
function getCellPosition(cellIndex, rowIndex) {
    return "".concat((0, StringUtils_1.toLetters)(cellIndex)).concat(rowIndex);
}
function convertSheet(sheet) {
    var result = {
        columnSize: sheet.columnSize,
        mergedCells: [],
        rowHeightMap: {},
        rows: sheet.paddingRowCount - 1 > 0 ? lodash_1.default.fill(Array(sheet.paddingRowCount - 1), []) : []
    };
    var rowIndex = sheet.paddingRowCount;
    var defaultCellIndex = sheet.paddingColumnCount + 1;
    lodash_1.default.forEach(sheet.rowClusters, function (rowCluster) {
        result.rows.push([]);
        rowIndex += 1;
        lodash_1.default.forEach(rowCluster.rows, function (row) {
            // Vertical Merge
            if (row.rowSize) {
                result.mergedCells.push("".concat(getCellPosition(defaultCellIndex, rowIndex), ":").concat(getCellPosition(defaultCellIndex, rowIndex - 1 + row.rowSize)));
            }
            var newRow = lodash_1.default.fill(Array(sheet.paddingColumnCount), {});
            var cellIndex = defaultCellIndex;
            result.rowHeightMap[rowIndex] = lodash_1.default.get(row, 'height', sheet.defaultRowHeight);
            lodash_1.default.forEach(row.cells, function (cell) {
                var tempCell = { key: cell.key, value: cell.value };
                if (cell.style) {
                    lodash_1.default.assign(tempCell, cell.style);
                }
                if (cell.formatter) {
                    lodash_1.default.assign(tempCell, { formatter: cell.formatter });
                }
                newRow.push(tempCell);
                if (cell.cellSize) {
                    var cellSize = cell.cellSize;
                    if (lodash_1.default.has(cell, 'rowSize') && lodash_1.default.get(cell, 'rowSize', false)) {
                        result.mergedCells.push("".concat(getCellPosition(cellIndex, rowIndex), ":").concat(getCellPosition(cellIndex + cellSize - 1, rowIndex - 1 + lodash_1.default.get(cell, 'rowSize', 0))));
                    }
                    else {
                        result.mergedCells.push("".concat(getCellPosition(cellIndex, rowIndex), ":").concat(getCellPosition(cellIndex + cellSize - 1, rowIndex)));
                    }
                    newRow.push.apply(newRow, new Array(cellSize - 1).fill({}));
                    cellIndex += cellSize;
                }
                else {
                    cellIndex += 1;
                }
            });
            result.rows.push(newRow);
            rowIndex += 1;
        });
    });
    return result;
}
// NOTE: 새로운 회사가 추가될 때마다 수정해야함
function getProperReportSheets() {
    var projectId = (0, Config_1.getProjectId)();
    if (projectId === 'dayouplus') {
        return (0, DayouReport_1.getDayouReportSheets)();
    }
    else if (projectId === 'tpc') {
        return (0, TPCReport_1.getTPCReportSheets)();
    }
    else if (projectId === 'helixmith') {
        return (0, HelixmithReport_1.getHelixmithReportSheets)();
    }
    return [];
}
function getDesignEvaluationDefs() {
    var reportSheets = getProperReportSheets();
    if (lodash_1.default.isEmpty(reportSheets)) {
        throw new Error('문제가 있습니다. 확인해주세요.');
    }
    var designEvaluationDefs = {};
    lodash_1.default.forEach(reportSheets, function (sheetDef) {
        designEvaluationDefs["".concat(sheetDef.name)] = convertSheet(sheetDef);
    });
    return designEvaluationDefs;
}
exports.getDesignEvaluationDefs = getDesignEvaluationDefs;
//# sourceMappingURL=ReportUtils.js.map